<template>
  <div class="home-box">
    <headerBlack-view class="black"></headerBlack-view>
    <div class="home-page">
      <div class="banner-wrapper">
        <el-carousel class="swiper" arrow="never" ref='carousel' :height="imgHeight">
          <el-carousel-item v-for="(item, index) in imgList" :key="index" class="item">
            <img :src="item.idView" alt="" ref="imgHeight" class="banner" @load="imgLoad">
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 主要内容 -->
      <div class="container-wrapper wrapper">
        <!-- 新闻模块 -->
        <div class="news-part">
          <div class="news flex-between">
            <div class="news-carousel">
              <el-carousel indicator-position="outside" :autoplay="false">
                <el-carousel-item v-for="(item, index) in carouselNewsList" :key="index">
                  <div class="news-carousel-item csp" @click="$router.push(`/home/news/detail/${item.id}?type=${1}`)">
                    <img :src="item.cover" alt="">
                    <p>{{ item.title }}</p>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="news-main">
              <div class="news-title flex-between">
                <div>
                  <span class="tab csp" v-for="(item, index) in ['最新动态']" :key="index"
                    :class="{ 'active-tab': activeTab === index }" @click="toggleTab(index)">
                    {{ item }}
                  </span>
                </div>
                <!-- <button class="news-more csp" @click="$router.push(`/home/news?type=${1}`)">
                  更多<i class="el-icon-arrow-right" style="font-size:12px"></i>
                </button> -->
              </div>
              <div class="news-list">
                <h6 v-for="(item, index) in noticeAndEduList" :key="index" class="flex-between article-title csp"
                  @click="$router.push(`/detail/${item.id}?type=${1}`)">
                  <p class="wes">{{ item.title }}</p>
                  <span class="date">{{ dayjs(item.createTime).format('YYYY-MM-DD') }}</span>
                </h6>
              </div>
            </div>
          </div>
        </div>
        <!-- 平台介绍 -->
      </div>
      <div class="platform">
        <h3 class="title">
          了解我们的服务平台
          <p>聚焦课程 · 聚焦课堂 · 聚焦学习</p>
        </h3>
        <div class="platform-ul-wrapper">
          <ul class="platform-ul">
            <li v-for="item in platformList" :key="item.id" class="platform-li csp" @click="toServePage(item)">
              <img :src="item.img" alt="" class="platform-li-img">
              <!-- <div class="platform-info"> -->
              <h4 class="platform-li-title">{{ item.title }}</h4>
              <p class="platform-li-discribe">{{ item.discribe }}</p>
              <div class="platform-li-subDiscribe">
                <p v-for="(each, index) in item.subDiscribe" :key="index">{{ each }}</p>
              </div>
              <!-- </div> -->
            </li>
          </ul>
        </div>

      </div>

      <!-- 品牌描述 -->
      <div class="introduce">
        <h3 class="title">
          品牌介绍
          <p>平台 · 终端 · 数据 · 应用</p>
        </h3>
        <img src="../../assets/home/describe.png" alt="" class="img-describe">
      </div>
      <!-- 案例 -->
      <div class="case">
        <h3 class="title">
          我们的案例
          <p>我们的每一个案例，都有精彩教育故事</p>
        </h3>
        <ul class="case-ul">
          <li class="case-li csp" v-for="item in caseList" :key="item.id" @mouseenter="enterCase(item)"
            @mouseleave="leaveCase(item)" @click="$router.push('/case')" :class="{ 'active': currentHover == item.id }">
            <p class="case-li-name">{{ item.name }}</p>
            <img :src="item.img" alt="" class="case-li-img">
            <div class="case-li-info">
              <p>{{ item.title }}</p>
              <span>{{ item.discribe }}</span>
              <button class="csp">了解更多<i class="el-icon-arrow-right" style="font-size:12px"></i></button>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: 0,
      imgHeight: '500px',
      carouselNewsList: [],
      noticeAndEduList: [],
      pages: { //分页
        currentPage: 1,
        pageSize: 3,
        total: 0,
      },
      // eduInfoList:[],
      imgList: [
      //   {
      //   id: 0,
      //   idView: require('../../assets/home/banner.png')
      // }, 
      {
        id: 1,
        idView: require('../../assets/home/banner2.png')
      },
      // {
      //   id: 2,
      //   name: '详情',
      //   idView: require('../../assets/home/banner3.png')
      // },
      ],
      newsList: [],
      platformList: [{
        id: 11,
        img: require("../../assets/home/1.png"),
        title: '课程中台',
        discribe: '探索学生自适应学习，精准推送学习资源',
        subDiscribe: [' 促进学校课程建设', '助力教师教学教研', '实现学生自主学习'],
        url: '/courseList',
      },
      {
        id: 12,
        img: require("../../assets/home/2.png"),
        title: '融合教学',
        discribe: '支撑教与学模式创新，实现个性化精准学习',
        subDiscribe: ['创新课程模式', '创新课堂教学', '创新学习方式'],
        url: '/integratedTaching',
      }, {
        id: 13,
        img: require("../../assets/home/3.png"),
        title: '评价诊断',
        discribe: '数据驱动育人，让成长更科学',
        subDiscribe: [' 面向教师、学生', '面向学校', '面向区域'],
        url: '/evaluation',
      }, {
        id: 14,
        img: require("../../assets/home/4.png"),
        title: '教师智研',
        discribe: '支撑教师发展，培养卓越教师',
        subDiscribe: ['教师培训', '教研服务', '常态活动'],
        url: '/wisdom',
      }
      ],
      caseList: [{
        id: 1,
        name: '互助工程',
        img: require("../../assets/home/case1.png"),
        title: '首都教育远程互助工程',
        discribe: '探索实践教育扶贫支援新模式，利用北京市优质教育资源，成为全国教育精准扶贫支援的一面旗帜',
      },
      {
        id: 2,
        name: '通用语言',
        img: require("../../assets/home/case2.png"),
        title: '通用语言文字',
        discribe: '探索实践教育扶贫支援新模式，利用北京市优质教育资源，成为全国教育精准扶贫支援的一面旗帜',
      },
      {
        id: 3,
        name: '三科统编',
        img: require("../../assets/home/case3.png"),
        title: '三科统编教材培训',
        discribe: '探索实践教育扶贫支援新模式，利用北京市优质教育资源，成为全国教育精准扶贫支援的一面旗帜',
      },
      ],
      currentHover: 1,
    }
  },
  methods: {
    imgLoad() {
      this.$nextTick(() => {
        this.imgHeight = `${this.$refs.imgHeight[0].height}px`

      })
    },
    toggleTab(index) {
      this.activeTab = index;
      this.getNewsList(index + 2);
    },
    toServePage(item) {
      console.log('item----', item)
      sessionStorage.setItem('pageId', 1)
      sessionStorage.setItem('childPageId', item.id)
      this.$router.push(item.url);
    },
    enterCase(item) {
      this.currentHover = item.id;
    },
    leaveCase(item) {
      this.currentHover = 1;
    },
    // 请求头条新闻
    async getNewsList(type) {
      let that = this;
      let params = {
        clazz: type, //轮播图新闻
        isAsc: 'desc',
        pageNum: 1,
        pageSize: 5
      }

      let resData = await Api.NewHome.GetNewsList(params)
      console.log('resData----', resData)
      if (type == 1) this.carouselNewsList = resData.rows.slice(0, 5);
      if (type == 2 || type == 3) this.noticeAndEduList = resData.rows.slice(0, 6);
    },
  },
  mounted() {
    window.onresize = () => {
      if (JSON.stringify(this.$refs.imgHeight) == '[]') return;
      // 通过点语法获取img的height属性值
      this.imgHeight = `${this.$refs.imgHeight[0].height}px`
    }
    this.getNewsList(1);
    this.getNewsList(2);
  },
}
</script>

<style lang="less" scoped>
.home-box {

  .home-page {

    // 公共标题 start
    .title {
      text-align: center;
      margin-bottom: 45px;
      font-size: 32px;
      position: relative;
      padding: 50px 0 64px;
      z-index: 2;

      &>p {
        font-size: 19px;
        color: #9B9BA3;
        margin-top: 17px;
      }
    }

    // 公共标题 end

    // 顶部banner轮播 start
    .banner-wrapper {
      position: relative;

      /deep/ .el-carousel__container {
        height: 411px;
      }

      .banner {
        width: 100%;
        min-width: 1100px;
      }
    }

    .wrapper {
      width: 1200px;
      margin: 0 auto;
    }

    // 顶部banner轮播 end
    .container-wrapper {
      margin-top: 47px;
    }



    // 最新动态
    .news {
      margin-bottom: 65px;

      // 左侧轮播图
      .news-carousel {
        width: 600px;

        /deep/ .el-carousel__container {
          height: 383px;
        }

        .news-carousel-item {
          height: 100%;

          img {
            width: 100%;
            height: 100%;
          }

          p {
            position: relative;
            z-index: 99;
            margin-top: -68px;
            line-height: 68px;
            padding-left: 11px;
            font-size: 14px;
            color: #fff;
            background-color: rgba(0, 0, 0, .5);
          }
        }
      }

      // 右侧新闻
      .news-main {
        width: 540px;

        .news-title {
          border-bottom: 1px solid #DDDDDD;
          height: 35px;

          .tab {
            font-size: 22px;
            padding: 0 16px;
            color: #999;
          }

          .active-tab {
            color: #508EF9;
            position: relative;

            &::after {
              position: absolute;
              content: " ";
              bottom: -12px;
              left: 50%;
              transform: translateX(-50%);
              width: 89px;
              height: 4px;
              background-color: #508EF9;
            }
          }

          .news-more {
            font-size: 15px;
            color: #999;
          }
        }

        .news-list {
          margin-top: 15px;
        }

        .article-title {
          color: #383838;
          font-size: 18px;
          line-height: 57px;
          padding-left: 2px;

          p {
            max-width: 380px;
          }

          &:hover {
            color: #3370FF;
          }
        }

        .date {
          color: #999;
          font-size: 15px;
        }
      }
    }

    // 平台介绍
    .platform {
      margin-bottom: 85px;


      .platform-ul-wrapper {
        padding: 60px 0;
        background-image: url("../../assets/home/platform-bg.png");
      }

      .platform-ul {
        width: 1200px;
        margin: 0 auto;
      }

      .platform-li {
        display: inline-block;
        box-shadow: 0px 0px 13px 0px rgba(127, 127, 127, 0.14);
        width: calc((100% / 4) - 10px);
        margin-right: 13px;
        text-align: center;
        transition: 1s all;
        background-color: #fff;

        &:hover {
          transform: translateY(-20px);
        }

        &:nth-child(4) {
          margin-right: 0;
        }

        .platform-li-title {
          font-size: 28px;
          color: #383838;
          margin: 20px 0 15px;

          &::after {
            content: ' ';
            display: block;
            margin: 17px auto 0;
            width: 65px;
            height: 2px;
            background: #3370FF;
          }
        }

        .platform-li-discribe {
          color: #999;
          margin-bottom: 24px;
        }

        .platform-li-subDiscribe {
          margin-bottom: 23px;


          &>p {
            margin: 0 auto 16px;
            width: 189px;
            line-height: 37px;
            font-size: 16px;
            color: #383838;
            background: rgba(238, 238, 238, 0.55);
          }
        }
      }


    }

    .introduce {
      margin: 84px 0;

      // 图片描述
      .img-describe {
        margin: 65px auto 0px;
        display: block;
        max-width: 100%;
      }
    }



    .case {
      .case-li {
        float: left;
        width: 294px;
        height: 635px;
        transition: width 1.5s;
        position: relative;
        overflow: hidden;

        &.active {
          width: calc(100% - (294px * 2));

          .case-li-name {
            visibility: hidden;
          }

          .case-li-info {
            visibility: visible;
          }
        }
      }

      .case-li-name {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%);
        color: #fff;
        font-size: 30px;
        visibility: visible;
      }

      .case-li-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }


      .case-li-info {
        position: absolute;
        background: RGBA(33, 54, 102, 0.7);
        bottom: 0;
        left: 0;
        width: 1332px;
        padding: 0 12%;
        box-sizing: border-box;
        visibility: hidden;

        &>p {
          display: block;
          color: #fff;
          font-size: 30px;
          margin-top: 23px;
          margin-bottom: 13px;
        }

        &>span {
          display: inline-block;
          color: #fff;
          font-size: 16px;
          margin-bottom: 21px;
        }

        &>button {
          color: #fff;
          float: right;
        }
      }
    }



    @media screen and (max-width:1250px) {
      /deep/.banner-wrapper .el-carousel__container {
        height: 500px;
      }

      .title {
        margin-bottom: 30px;
        font-size: 26px;
        padding: 41px 0 53px;

        &>p {
          font-size: 16px;
          margin-top: 14px;
        }
      }

      // 最新动态
      .news {
        margin-bottom: 54px;

        // 左侧轮播图
        .news-carousel {
          width: 495px;

          /deep/ .el-carousel__container {
            height: 316px;
          }

          .news-carousel-item {
            p {
              margin-top: -56px;
              line-height: 56px;
            }
          }
        }

        // 右侧新闻
        .news-main {
          width: 444px;

          .news-title {
            height: 31px;

            .tab {
              font-size: 18px;
              padding: 0 13px;
            }

            .news-more {
              font-size: 12px;
            }
          }

          .article-title {
            font-size: 15px;
            line-height: 48px;

            p {
              max-width: 350px;
            }
          }

          .date {
            font-size: 12px;
          }
        }


      }

      // 平台介绍
      .platform {
        margin-bottom: 55px;

        .platform-li {
          width: calc((100% / 4) - 9px);
          margin-right: 11px;

          .platform-li-title {
            font-size: 23px;
            margin: 17px 0 12px;

            &::after {
              margin: 14px auto 0;
              width: 54px;
            }
          }

          .platform-li-img {
            max-width: 100%;
          }

          .platform-li-discribe {
            color: #999;
            margin-bottom: 20px;
            font-size: 12px;
          }

          .platform-li-subDiscribe {
            margin-bottom: 32px;


            &>p {
              margin: 0 auto 13px;
              width: 156px;
              line-height: 31px;
              font-size: 13px;
            }
          }
        }
      }

      .case {
        .case-li {
          width: 243px;
          height: 524px;

          &.active {
            width: calc(100% - (243px * 2));
          }
        }

        .case-li-name {
          height: 524px;
          font-size: 25px;
        }

        .case-li-info {
          width: 1100px;
          padding: 0 5%;

          &>p {
            font-size: 25px;
            margin-top: 19px;
            margin-bottom: 11px;
          }

          &>span {
            font-size: 13px;
            margin-bottom: 17px;
          }
        }
      }
    }
  }
}
</style>